module.exports = __webpack_public_path__ + "img/sld_scb_40_t1_b1_green.5164a15d.svg";